// extracted by mini-css-extract-plugin
export default {"container":"machine-relations_container__R8NMy","queryContainer":"machine-relations_queryContainer__rA9u5","queryButton":"machine-relations_queryButton__50zWH"};